import React, { useState, useEffect, useRef } from "react";
import style from "./Select.module.css";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

function Select(props) {
  const [ListShow, setListShow] = useState(false);
  const [selectData, setSelect] = useState(props.defaultTxt);

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  const ToggleSelect = () => {
    setListShow(!ListShow);
  };

  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setListShow(false);
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  useEffect(()=>{
    setSelect(props.defaultTxt);
  },[props.defaultTxt])
  
  useEffect(() => {
    if (props.reset === true) {
      setSelect(props.defaultTxt);
    }
  }, [props.reset]);
  

  return (
    <div className={`${style.DropDown_select} ${props.className}`} style={props.style} ref={wrapperRef}>
      <p className={style.DropDown_select_msg} style={{ marginTop: "20px" }}>
        {props.headLable ? props.headLable : ""}
      </p>

      <div className={style.DropDown_select_Toggler} onClick={ToggleSelect}>
        <label>{selectData}</label>

        <ArrowDropDownIcon
          style={{
            marginTop: "7px",
            
            transform: ListShow && "rotateZ(180deg)",
          }}
        />
      </div>

      {ListShow && (
        <>
          <div style={{ height: "0px" }}>
            {" "}
            <div className={style.DropDown_select_options} >
              {props.menu ? (
                props.menu.map((item, i) => {
                  return (
                    <p
                      onClick={() => {
                        setSelect(item[props.howToAccess]);
                        props.setter(item[props.getField]);
                        setListShow(false);
                      }}
                      key={i}
                    >
                      {item[props.howToAccess]}
                    </p>
                  );
                })
              ) : (
                <p style={{ textAlign: "center" }}>No Data Found</p>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default Select;
